<div id="cta-dto-inversores-segofinance" class="py-5 pb-5 px-1 px-lg-5 bg-primary-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="p-4 p-lg-5 border-radius-4 bg-primary-900 text-white">
                    <div class="row d-flex align-items-center px-0 px-lg-5">
                        <div class="col-12 col-lg-8">
                            <p><strong class="p1-bold">O si lo prefieres cierra una cita con nuestro Departamento de Inversores</strong></p>
                            <p class="p1-regular mb-0">
                                Desde el <strong class="p1-bold">Grupo SEGOFINANCE</strong> ponemos a tu disposición un
                                equipo experto que te ayudará a seleccionar los <strong class="p1-bold">productos que más
                                    se ajustan a tu perfil en función de tus objetivos</strong>.
                            </p>
                        </div>
                        <div class="col-12 col-lg-4 text-center mt-4 mt-lg-0">
                            <a class="btn btn-secondary px-5 d-none d-lg-inline-flex"
                                href="https://outlook.office365.com/book/SEGOInversores@segofinance.com/?month=2023-07" target="_blank"
                                title="Solicitar cita">Solicitar cita</a>
                            <a class="btn btn-secondary px-5 d-block d-lg-none w-100 mb-2"
                                href="https://outlook.office365.com/book/SEGOInversores@segofinance.com/?month=2023-07" target="_blank"
                                title="Solicitar cita">Solicitar cita</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>